export default "__VITE_ASSET__HQby4yyx__"